/* eslint-disable max-len */
import React, { useMemo } from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import CustomAccordion from '../common/CustomAccordion';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      margin: '60px auto 100px',
      maxWidth: '800px',
      padding: '0px 30px',
    },
    faqContainer: {
      paddingTop: '30px',
    },
    faqItem: {
      backgroundColor: '#F5F5F5',
      borderRadius: '5px',
      marginBottom: '20px',
      padding: '17px 20px',
      textAlign: 'left',
    },
    itemDesc: {
      color: '#172B4D',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '24px',
      marginBottom: '0px !important',
      marginTop: '20px',
    },
    itemTitle: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: '700',
      lineHeight: '27px',
      marginBottom: '0px !important',
    },
    title: {
      color: '#172B4D',
      fontSize: '24px',
      fontWeight: '700',
      lineHeight: '36px',
      marginBottom: '30px !important',
      textAlign: 'center',
    },

    [theme.breakpoints.up('md')]: {
      container: {
        margin: '46px auto 120px',
      },
      faqContainer: {
        paddingTop: '40px',
      },
      faqItem: {
        padding: '20px',
      },
      itemDesc: {
        marginTop: '10px',
      },
      itemTitle: {
        fontSize: '22px',
        lineHeight: '32px',
      },
      title: {
        fontSize: '34px',
        lineHeight: '52px',
        marginBottom: '40px',
      },
    },
  };
});

const faqList = [
  {
    description:
      'Once you have made payment and Mediphany has received your radiology images and report, our team will be sent through to a screen where you will be able to upload your radiology images and radiology report. You will also be given the option to ask any questions you have before submitting through to our team to complete the video report.',
    id: 'med_faq_1',
    title: 'What happens after I make payment?',
  },
  {
    description:
      "If you don't have either your radiology images or report, you can reach out to our team at info@mediphany.com and we will gladly help you get them from your imaging center. We can also make a video explanation of your text report alone, though we recommend getting your images so you can be shown your findings directly.",
    id: 'med_faq_2',
    title: "What if I don't have my radiology files?",
  },
  {
    description: 'If your clinic has provided you with a physical copy of your radiology report you can simply take a photo of the feedback and upload that.',
    id: 'med_faq_3',
    title: 'What if I have a physical radiology report?',
  },
  {
    description:
      'The length of your video report depends on the complexity of the findings, but typically our personal reports range from 5-10 minutes in length and there are additional videos provided to enhance your understanding.',
    id: 'med_faq_4',
    title: 'How long will my video report be?',
  },
  {
    description:
      'If you select the standard report, your video report will be available to you in less than 5 days from the time we receive your images and text report. If you select the express report, then your video report will be available in less than 48 hours from the time we receive your images and text report.',
    id: 'med_faq_5',
    title: 'How long will it take to receive my video report?',
  },
  {
    description: 'Yes, our radiologists can give detailed video explanations for any type of condition that can be detected on the imaging study.',
    id: 'med_faq_6',
    title: 'Can Mediphany do this for any type of radiology study or condition?',
  },
  {
    description:
      'Yes, absolutely. Our systems have been developed from the start with security in mind and we ensure that we are HIPAA compliant for maximum security. Nobody outside of Mediphany will be able to view your video report or imaging files unless you have invited them to do so.',
    id: 'med_faq_7',
    title: 'Is my medical information safe?',
  },
];

export default ({ userDetails }) => {
  const classes = useStyles();

  const canRequestBeforePay = useMemo(() => {
    return userDetails?.workspace?.canRequestBeforePay;
  }, [userDetails]);

  const faqData = useMemo(() => {
    const faqs = [...faqList];
    if (canRequestBeforePay) faqs.shift();

    return faqs;
  }, [canRequestBeforePay]);

  const RenderTitle = (title) => {
    return <Typography className={classes.itemTitle}>{title}</Typography>;
  };

  const RenderDescription = (description) => {
    return <Typography className={classes.itemDesc}>{description}</Typography>;
  };

  return (
    <div className={classes.container}>
      <Typography className={classes.title}>Frequently Asked Questions</Typography>

      <div className={classes.faqContainer}>
        {faqData.map((faq) => (
          <div key={faq.id} className={classes.faqItem}>
            <CustomAccordion title={RenderTitle(faq.title)}>{RenderDescription(faq.description)}</CustomAccordion>
          </div>
        ))}
      </div>
    </div>
  );
};
